module.exports = __webpack_public_path__ + "static/media/opakowania_2_C.219bd863.png";